module.exports = __webpack_public_path__ + "media/images/favicons/halftimetalentconnect-8ef039a785f67810e422931c4075c5bbffbb5300d3e644eeb2c07d5ff9067dcc.ico";